<template>
  <!-- 受注一覧 -->
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <t-row class="col_common_center">
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 新規 -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-button
              round
              type="primary"
              class="button_common"
              ref="addAcceptBtn"
              @click="addAcceptClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.COMMON_CONSTANT.ADD") }}
            </t-button> -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
          </t-col>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.COMMON_CONSTANT.DELETE") }}
            </t-button></t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 出力 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="outPutBtn"
              @click="outPutClick"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.ACCEPT_ORDER.OUTPUT_BTN") }}
            </t-button>
          </t-col>
        </t-row>
        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_受注一覧画面の検索条件と検索結果の追加 -->
                <!-- <t-col :span="12"> -->
                <!-- 受注/納期 -->
                <!-- <div> -->
                <!-- <t-form-item class="dateLabelWidth" label-width="180px">
                      <span slot="label">
                        <div style="margin-top: 1px">
                          <t-radio-group
                            v-model="acceptDateLabel"
                            size="small"
                            style="margin-right: 5px"
                          > -->
                <!-- 受注 -->
                <!-- <t-radio-button label="1">
                              {{
                                $t("resource.ACCEPT_ORDER.ACCEPT_DATE")
                              }}</t-radio-button
                            > -->
                <!-- 納期 -->
                <!-- <t-radio-button label="2">{{
                              $t("resource.ACCEPT_ORDER.DELIVERY_DATE")
                            }}</t-radio-button>
                          </t-radio-group>
                        </div>
                      </span> -->

                <!-- 受注/納期(開始日～終了日) -->
                <!-- <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="margin-left: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="false"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >   -->
                <t-col :span="8">
                  <!-- 得意先納期 -->
                  <div>
                    <t-form-item
                      :label="
                        $t('resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE')
                      "
                      label-width="$t('widgetSize.COMMON_WIDTH.NINETY_PX')"
                    >
                      <!-- 得意先納期(開始日～終了日) -->
                      <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓ -->
                      <!-- クリア可能 -->
                      <!-- <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="false"
                        style="min-width: 20px; width: 75%; margin-left: -3px"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                      </t-date-picker> -->
                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="true"
                        style="min-width: 20px; width: 75%; margin-left: -3px"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                      </t-date-picker>
                      <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑ -->
                      <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->
                    </t-form-item>
                  </div>
                </t-col>
                <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_受注状態が非表示になる対応 -->
                <!-- <t-col :span="5"> -->
                <!-- 状態 -->
                <!-- <t-form-item :label="$t('resource.ACCEPT_ORDER.STATUS')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item> -->
                <!-- </t-col> -->
                <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->

                <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_受注一覧画面の検索条件と検索結果の追加 -->
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="8" class="right">
                  <!-- 仕入先納期 -->
                  <div>
                    <t-form-item
                      :label="
                        $t('resource.ACCEPT_ORDER.SUPPLIER_DELIVERY_DATE')
                      "
                      label-width="$t('widgetSize.COMMON_WIDTH.NINETY_PX')"
                    >
                      <!-- 仕入先納期(開始日～終了日) -->
                      <t-date-picker
                        v-model="dateSupRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        style="min-width: 20px; width: 75%; margin-left: -3px"
                        class="date_icon_center"
                        :clearable="true"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="4">
                  <template>
                    <!-- 未入荷 -->
                    <t-checkbox
                      v-model="rcvRemainFlg"
                      :label="$t('resource.ACCEPT_ORDER.REC_REMAIN_FLG')"
                      style="line-height: 3"
                    />
                  </template>
                </t-col>
                <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->
              </t-row>

              <t-row>
                <t-col :span="1">&nbsp; </t-col>
                <t-col :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="4" class="col_common_left">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>
      <div></div>

      <div class="div_content">
        <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
        <!-- 課題_受注一覧画面の検索条件と検索結果の追加 -->
        <!-- <t-table
          ref="acceptOrderTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
          fit
        >
        <t-table-column type="selection" class-name="cell_txt_center" /> -->

        <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓ -->
        <!-- <t-table
          ref="acceptOrderTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          :cell-class-name="tableCellClassName"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
          fit
          row-key="id"
          default-expand-all
        > -->
        <t-table
          ref="acceptOrderTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          :cell-class-name="tableCellClassName"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
          fit
          row-key="id"
          default-expand-all
          @select-all="handleSelectAll"
        >
          <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑ -->
          <t-table-column type="selection" class-name="cell_txt_center">
            <template slot-scope="scope">
              <t-checkbox
                v-if="scope.row.id < 10000"
                v-model="scope.row.isSelected"
                @change="handleSelectionChange(scope.row, $event)"
              ></t-checkbox>
            </template>
          </t-table-column>
          <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->
          <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
          <!-- 課題_受注状態が非表示になる対応 -->
          <!-- 状態 -->
          <!--  <t-table-column
            prop="aobAcceptState"
            :label="$t('resource.ACCEPT_ORDER.STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.ACCEPT_ORDER.STATUS'),
                'aobAcceptState'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.aobAcceptState }} </span>
              </div>
            </template>
          </t-table-column> -->
          <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <!-- ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_受注一覧画面の検索条件と検索結果の追加 -->
            <template slot-scope="scope">
              <span>
                {{ scope.row[column.prop] }}
              </span></template
            >
            <!-- ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->
          </t-table-column>

          <!-- 注文 -->
          <t-table-column
            prop="aobOrderStatus"
            :label="$t('resource.ACCEPT_ORDER.ORDER')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.ACCEPT_ORDER.ORDER'),
                'aobOrderStatus'
              )
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="
                    isDateDiffLessThanOneDay(
                      new Date(),
                      new Date(row.aobOrderTime),
                      hintUpdateHour
                    )
                  "
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>

          <!-- 入荷 -->
          <t-table-column
            prop="aobReceiveStatus"
            :label="$t('resource.ACCEPT_ORDER.CHECK_RECEIVE_STATUS')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.ACCEPT_ORDER.CHECK_RECEIVE_STATUS'),
                'aobReceiveStatus'
              )
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="
                    isDateDiffLessThanOneDay(
                      new Date(),
                      new Date(row.aobReceTime),
                      hintUpdateHour
                    )
                  "
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>

          <!-- 出荷 -->
          <t-table-column
            prop="aobOutboundStatus"
            :label="$t('resource.ACCEPT_ORDER.CHECK_OUTBOUND_STATUS')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.ACCEPT_ORDER.CHECK_OUTBOUND_STATUS'),
                'aobOutboundStatus'
              )
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="
                    isDateDiffLessThanOneDay(
                      new Date(),
                      new Date(row.aobOutTime),
                      hintUpdateHour
                    )
                  "
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>

          <!-- 請求 -->
          <t-table-column
            prop="aobRequestStatus"
            :label="$t('resource.ACCEPT_ORDER.REQUEST_STATUS')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.ACCEPT_ORDER.REQUEST_STATUS'),
                'aobRequestStatus'
              )
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="
                    isDateDiffLessThanOneDay(
                      new Date(),
                      new Date(row.aobRequestTime),
                      hintUpdateHour
                    )
                  "
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="acceptOrderTableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { ShowAcceptEditDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  deleteAcceptInfoByQuoteNo,
  initAcceptOrderSearchList,
  searchAcceptOrderBasic,
} from "@/services/acceptOrder";
import { outputExcelToZip } from "@/services/common";
import {
  formatDateStrToString,
  formatDateToString,
  getNextMonthDate,
} from "@/utils/comFunction";
import {
  AOB_ORDER_STATUS_ORDERED,
  GetPageDataCount,
  STR_ONE,
  STR_TWO,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      dateRange: [],
      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
      rcvRemainFlg: false, // 未入荷
      // 課題_受注一覧画面の検索条件と検索結果の追加
      dateSupRange: [], // 仕入先納期

      selectedRows: [], // 選択行のデータ
      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
      searchConditionForm: {
        searchStartDate: "",
        searchEndDate: "",
        searchStatus: "",
        searchWord: "",
        // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
        // 課題_受注一覧画面の検索条件と検索結果の追加
        // isAcceptDate: true,

        searchSupStartDate: "", // 開始日（仕入先納期）
        searchSupEndDate: "", // 終了日（仕入先納期）
        rcvRemainExist: "", //入荷残有
        // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
      },

      //受注または納期フラグ
      acceptDateLabel: "1",

      //受注テーブル
      acceptOrderTableData: [],

      //受注状態:新規、処理中、終了
      statusList: [],

      //提示更新時間
      hintUpdateHour: 0,

      showFlag: false,

      columns: [
        // 見積No.
        // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
        // 課題_受注一覧画面の検索条件と検索結果の追加
        // {
        //   prop: "aobQuoteNo",
        //   label: t("resource.COMMON_CONSTANT.ESTIMATED_NO"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        // },
        {
          prop: "aobQuoteNoShow",
          label: t("resource.COMMON_CONSTANT.ESTIMATED_NO"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
        },
        // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
        // 受注日
        {
          prop: "aobAcceptDate",
          label: t("resource.ACCEPT_ORDER.ACCEPT_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },

        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // // 注番
        // {
        //   prop: "aobCusOrderNo",
        //   label: t("resource.ACCEPT_ORDER.CUS_ORDER_NO"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        // },
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 得意先納期
        {
          prop: "aobCusDeliveryDate",
          // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
          // 課題_受注一覧画面の検索条件と検索結果の追加
          // label: t("resource.ACCEPT_ORDER.DELIVERY_DATE"),
          label: t("resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE"),
          // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },

        // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
        // 課題_受注一覧画面の検索条件と検索結果の追加
        // 仕入先納期
        {
          prop: "aobSupDueDate",
          label: t("resource.ACCEPT_ORDER.SUPPLIER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        //　仕入先
        {
          prop: "aobSupCode",
          label: t("resource.ACCEPT_ORDER.SUPPLIER_COMPANY"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑

        // 得意先
        {
          prop: "aobCusCode",
          label: t("resource.ACCEPT_ORDER.CUS_NAME"),
          // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
          // 課題_受注一覧画面の検索条件と検索結果の追加
          width: t("widgetSize.tableCommon.width120"),
          // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先担当者
        {
          prop: "aobCusUserCode",
          label: t("resource.ACCEPT_ORDER.CUS_USER_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 連絡担当
        {
          prop: "aobUserName",
          label: t("resource.ACCEPT_ORDER.CONNECTER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 見積ターブル
        {
          prop: "aobQuoteType",
          label: t("resource.ORDER.QUOTE_TYPE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      ],
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      acceptOrderTableDatalength: 10,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    };
  },

  mounted() {
    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  computed: {
    tableData() {
      return this.acceptOrderTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    //新規ボタン
    addAcceptClick() {
      // 受注一覧詳細画面を表示
      ShowAcceptEditDialog(
        {
          isAdd: true,
        },
        t("resource.ACCEPT_ORDER.ACCEPT_DETAIL_TITLE"),
        this.init
      );
      // フォーカス削除
      this.$refs.addAcceptBtn.$el.blur();
    },

    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },
    //状態背景色
    formatStatusColor(row) {
      return this.statusList.find((it) => it.label === row.aobAcceptState)
        ?.statusColor;
    },
    // 初期化
    init() {
      this.showFlag = true;

      //検索条件リストの初期化(状態)
      initAcceptOrderSearchList()
        .then((res) => {
          this.$nextTick(() => {
            //受注状態
            this.statusList = res.searchStatus;
            //提示更新時間
            this.hintUpdateHour = Number(res.hintUpdateHour);
          });

          //日付初期化
          this.dateInit();

          //検索処理
          this.searchClick();
        })
        .catch(() => {
          this.showFlag = false;
          Message.showError(
            t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
          );
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();

      //日付初期値の設定:受注日・納期(開始～終了)
      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      //this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
      this.dateRange = [systemDate, getNextMonthDate(systemDate)];
      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
      // 課題_受注一覧画面の検索条件と検索結果の追加
      // 仕入先納期
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // this.dateSupRange = [getPreviousMonthDate(systemDate), systemDate];
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
    },

    //複数行データの削除
    deleteClickSelected() {
      // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
      // 課題_受注一覧画面の検索条件と検索結果の追加
      // let data = this.$refs.acceptOrderTableData.selection;
      let data = this.selectedRows;
      // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑

      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        for (let index = 0; index < data.length; index++) {
          let dataStatus = this.statusList.find(
            (it) => it.label === data[index].aobAcceptState
          )?.value;

          //注文済みのデータは削除不可
          if (data[index].isOrdered == AOB_ORDER_STATUS_ORDERED) {
            deleteFlg = false;
            // UPD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓
            // Modal.showError("", t("message.ACCEPT_ORDER.NOT_DELETE"));
            // break;
            Modal.showError("", t("message.ACCEPT_ORDER.NOT_DELETE"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            break;
            // UPD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑
          }

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          //請求したデータは削除不可
          if (data[index].requestFlg === STR_ONE) {
            deleteFlg = false;
            Modal.showError("", t("message.ACCEPT_ORDER.NOT_DELETE_REQUEST"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            break;
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          delList.push(data[index].aobQuoteNo);
        }

        //削除可能の場合
        if (deleteFlg) {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
              cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
              showCancelButton: true,
            }
          ).then(() => {
            /// UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
            // deleteAcceptInfoByQuoteNo({ delList: delList })
            //   .then(() => {
            //     //削除成功
            //     Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
            //   })
            //   .catch((err) => {
            //     if (err.data != null) {
            //       Message.showError(
            //         t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            //       );
            //     } else {
            //       Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
            //     }
            //   })
            //   .finally(() => {
            //     //検索処理を行う
            //     this.searchClick();
            //   });

            //フォーカスの設定
            setTimeout(() => {
              let button = document.querySelector(".el-button--primary");
              if (button) {
                button.focus();
              }
            }, 100);

            // 受注データ取込詳細の対応データを削除
            Modal.showWarning(
              "",
              t("message.ACCEPT_ORDER.DATA_IMPORT_DELETE_CHECK"),
              {
                $type: "prompt",
                confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
                cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
                showCancelButton: true,
              }
            )
              .then(() => {
                //confirm処理
                // 受注データ取込詳細の対応データを削除
                this.deleteDataProc(STR_TWO, delList);
              })
              .catch(() => {
                //cancel処理
                // 受注データ取込詳細の対応データを削除しばい
                this.deleteDataProc(STR_ONE, delList);
              });
            // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //データ削除処理
    deleteDataProc(kbn, delList) {
      //kbn   1:削除しない  2:削除
      deleteAcceptInfoByQuoteNo({ delList: delList, importDateDelFlg: kbn })
        .then(() => {
          //削除成功
          Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
          }
        })
        .finally(() => {
          //検索処理を行う
          this.searchClick();
        });
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    //「検索」ボタン
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //検索条件の処理
      this.updateSearchForm();

      //検索受注台帳基本情報
      searchAcceptOrderBasic(this.searchConditionForm)
        .then((res) => {
          this.acceptOrderTableData = res;

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));

          this.acceptOrderTableDatalength = res.length;
          // データ処理
          this.dataProcess();

          // DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
          // 課題_受注一覧画面の検索条件と検索結果の追加
          // setColumnWidth(this.columns, this.acceptOrderTableData);
          // DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
        })
        .catch((err) => {
          Message.showError(
            t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
          );
        })
        .finally(() => {
          this.showFlag = false;
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          if (typeof this.$refs.searchBtn !== "undefined") {
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
            // フォーカス削除
            this.$refs.searchBtn.$el.blur();
          }
        });
    },

    //検索条件の調整
    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      // DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
      // 課題_受注一覧画面の検索条件と検索結果の追加
      //日付チェック区分の設定
      // this.searchConditionForm.isAcceptDate =
      // this.acceptDateLabel === "1" ? true : false;
      // DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑

      //受注日·納期が空でない場合
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = "";
        this.searchConditionForm.searchEndDate = "";
      }

      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
      // 課題_受注一覧画面の検索条件と検索結果の追加
      //仕入先納期が空でない場合
      if (this.dateSupRange) {
        this.searchConditionForm.searchSupStartDate = formatDateToString(
          this.dateSupRange[0]
        );
        this.searchConditionForm.searchSupEndDate = formatDateToString(
          this.dateSupRange[1]
        );
      } else {
        this.searchConditionForm.searchSupStartDate = "";
        this.searchConditionForm.searchSupEndDate = "";
      }
      // 未入荷
      this.searchConditionForm.rcvRemainExist = this.rcvRemainFlg;
      // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
    },

    //出力
    outPutClick() {
      this.showFlag = true;

      //検索条件の調整
      this.updateSearchForm();

      //採番台帳情報出力
      outputExcelToZip(
        httpApi.OutPutAcceptOrderExcel,
        this.searchConditionForm
      ).finally(() => {
        this.showFlag = false;
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      });
    },

    //詳細
    detailClick(row) {
      // 受注一覧詳細画面を表示
      ShowAcceptEditDialog(
        {
          isAdd: false,
          rowData: row,
        },
        t("resource.ACCEPT_ORDER.ACCEPT_DETAIL_TITLE"),
        this.searchClick
      );
    },

    //データの処理
    dataProcess() {
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 得意先納期の列幅フラグ（true:増加）
      var cusDeliveryDateChangeWidth = false;
      // 仕入先納期の列幅フラグ（true:増加）
      var supDueDateChangeWidth = false;
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      this.acceptOrderTableData.map((item) => {
        //受注状態の変換
        item.aobAcceptState = this.statusList.find(
          (it) => it.value === item.aobAcceptState
        )?.label;

        //受注日の変換
        item.aobAcceptDate = formatDateStrToString(item.aobAcceptDate);

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // //納期の変換
        // item.aobCusDeliveryDate = formatDateStrToString(
        //   item.aobCusDeliveryDate
        // );

        // 最小得意先納期と最大得意先納期
        var stringCusDeliveryDateMin = formatDateStrToString(
          item.aobCusDeliveryDateMin
        );
        var stringCusDeliveryDateMax = formatDateStrToString(
          item.aobCusDeliveryDateMax
        );
        //得意先納期の変換
        if (stringCusDeliveryDateMin == stringCusDeliveryDateMax) {
          item.aobCusDeliveryDate = stringCusDeliveryDateMin;
        } else {
          //得意先納期の列幅フラグ（true:増加）
          cusDeliveryDateChangeWidth = true;
          item.aobCusDeliveryDate =
            stringCusDeliveryDateMin + "～" + stringCusDeliveryDateMax;
        }

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
        // 課題_受注一覧画面の検索条件と検索結果の追加
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //// 仕入先納期の変換
        // item.aobSupDueDate = formatDateStrToString(item.aobSupDueDate);

        // 最小仕入先納期と最大仕入先納期
        var stringSupDueDateMin = formatDateStrToString(item.aobSupDueDateMin);
        var stringSupDueDateMax = formatDateStrToString(item.aobSupDueDateMax);
        //仕入先納期の変換
        if (stringSupDueDateMin == stringSupDueDateMax) {
          item.aobSupDueDate = stringSupDueDateMin;
        } else {
          //仕入先納期の列幅フラグ（true:増加）
          supDueDateChangeWidth = true;
          item.aobSupDueDate = stringSupDueDateMin + "～" + stringSupDueDateMax;
        }
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        if (item.childrenCount > 1) {
          item.children.map((sonItem) => {
            // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
            // sonItem.aobSupDueDate = formatDateStrToString(
            //   sonItem.aobSupDueDate
            // );

            // 最小仕入先納期と最大仕入先納期
            var stringSonSupDueDateMin = formatDateStrToString(
              sonItem.aobSupDueDateMin
            );
            var stringSonSupDueDateMax = formatDateStrToString(
              sonItem.aobSupDueDateMax
            );
            //仕入先納期の変換
            if (stringSonSupDueDateMin == stringSonSupDueDateMax) {
              sonItem.aobSupDueDate = stringSonSupDueDateMin;
            } else {
              //仕入先納期の列幅フラグ（true:増加）
              supDueDateChangeWidth = true;
              sonItem.aobSupDueDate =
                stringSonSupDueDateMin + "～" + stringSonSupDueDateMax;
            }
            // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          });
        }

        // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
      });

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 納期の列幅フラグ（true:増加）
      this.columns = this.columns.map((col) => {
        if (col.prop === "aobCusDeliveryDate") {
          return { ...col, width: cusDeliveryDateChangeWidth ? 200 : 100 };
        }
        if (col.prop === "aobSupDueDate") {
          return { ...col, width: supDueDateChangeWidth ? 200 : 100 };
        }
        return col;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    //日付の差が1日未満かどうか
    isDateDiffLessThanOneDay(date1, date2, hintUpdateHour) {
      //時間差
      const diff = Math.abs(date1 - date2);
      //1日:hintUpdateHour(24)
      const oneDayInMilliseconds = 1000 * 60 * 60 * hintUpdateHour;
      //時間差が1日未満の場合：true
      return diff < oneDayInMilliseconds;
    },

    // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
    // 課題_受注一覧画面の検索条件と検索結果の追加
    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // 選択列かどうかを判断する
      const isSelectionColumn = columnIndex === 0;

      var columnColorFlg =
        row.id >= 10000 &&
        ((column.property == "aobQuoteNoShow" && !row.aobQuoteNoShow) ||
          (column.property == "aobAcceptDate" && !row.aobAcceptDate) ||
          isSelectionColumn ||
          (column.property == "aobCusOrderNo" && !row.aobCusOrderNo) ||
          (column.property == "aobCusDeliveryDate" &&
            !row.aobCusDeliveryDate) ||
          (column.property == "aobCusCode" && !row.aobCusCode) ||
          (column.property == "aobCusUserCode" && !row.aobCusUserCode) ||
          (column.property == "aobUserName" && !row.aobUserName) ||
          (column.property == "aobQuoteType" && !row.aobQuoteType) ||
          (column.property == "aobOrderStatus" && !row.aobOrderStatus) ||
          (column.property == "aobReceiveStatus" && !row.aobReceiveStatus) ||
          (column.property == "aobOutboundStatus" && !row.aobOutboundStatus) ||
          (column.property == "aobRequestStatus" && !row.aobRequestStatus));

      if (columnColorFlg) {
        return "bg-cell-editable_grey";
      }
    },

    handleSelectionChange(row, event) {
      // 選択状態を変更する
      row.isSelected = event;

      // selectedRowsに同期
      if (row.isSelected) {
        this.selectedRows.push(row);
      } else {
        const index = this.selectedRows.findIndex((r) => r.id === row.id);
        if (index !== -1) {
          this.selectedRows.splice(index, 1);
        }
      }
    },
    // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
    // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
    // すべて選択
    handleSelectAll(selection) {
      const selectableRows = this.tableData.filter((row) => row.id < 10000);
      selectableRows.forEach((row) => {
        row.isSelected = selection.length > 0;
        this.handleSelectionChange(row, selection.length > 0);
      });
    },
    // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
    pageChange(val) {
      this.pageNo = val;
    },

    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //アダプティブ列幅
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.acceptOrderTableData);
    },
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1; /* 残りのスペースを2番目のspan要素に占有させ、コンテンツの配置を実現 */
}

// ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
// 課題_受注一覧画面の検索条件と検索結果の追加
.el-table__expand-icon {
  display: none !important;
}
// ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
</style>
